import service from './request'
import util from '@/util/util.js'
// 获取视频列表
export const videosList = data => {
    return service({
        url: `/videos?classifyName=${data.channelName}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'get',
    })
}

